import styled from "styled-components";

const Box = styled.ul`
  border: 0.2rem solid #98a8be;
  border-radius: 2.2rem;
  padding: 1rem 1.5rem;
  margin-bottom: 3.5rem;
`;

export default Box;
